import React, { useEffect } from 'react';
import { useSingleton } from '@bydesign-ui/hooks';
import { Group } from '../../../models/group';
import { GroupContext } from '../context/group';
export function RcGroup(props) {
  var group = useSingleton(function () {
    return new Group(props);
  });
  var extra = group.updateGroupOptions(props);
  useEffect(function () {
    return function () {
      return group.dispose();
    };
  }, []);
  return React.createElement(GroupContext.Provider, {
    value: group
  }, React.createElement("div", Object.assign({}, extra)));
}